module.exports = __webpack_public_path__ + "static/media/swap.40a76008.svg";